<template>
  <div class="h-full detail-w mx-auto" v-loading="fileLoading" ref="detailContainer">
    <div class="h-50px mb-50px">
      <NavigationBar :data="navigationData"></NavigationBar>
      <Breadcrumb :data="breadcrumbData" mode="view" class="mt-10px" />
    </div>
    <div class="column-detail mb-30px">
      <div
        class="mr-20px float-left"
        ref="column"
        :class="isShowSidebar ? 'w-[calc(100%-300px)]' : 'w-full'"
      >
        <div class="border-1px border-[#ccc] py-20px">
          <div ref="columnDetail">
            <div class="px-50px">
              <div class="text-25px font-bold text-center leading-24px detail-info">
                {{ detailInfo.title }}
              </div>
              <div
                class="text-18px text-center mt-10px leading-24px detail-info"
                v-if="detailInfo.subtitle"
              >
                {{ detailInfo.subtitle }}
              </div>
              <div
                class="flex justify-center mt-10px text-12px !leading-18px text-hex-333 detail-info column-author"
              >
                <div class="mr-15px text-center">作者：{{ detailInfo.author }}</div>
                <div class="mr-15px text-center">部门：{{ detailInfo.deptSourceName }}</div>
                <div class="text-center">发布时间： {{ detailInfo.editPublishTime }}</div>
              </div>
            </div>
            <div class="border-top-1px border-color-ccc mt-15px mb-10px"></div>
            <div class="px-50px">
              <div class="ql-container ql-snow">
                <div v-if="isVideoColumn" class="w-full pb-30px">
                  <video
                    style="width: 80%;height:500px;"
                    class="mx-auto"
                    :src="videoSrc"
                    controls
                  ></video>
                </div>
                <div v-else-if="!detailInfo.content || detailInfo.content === '<p><br></p>'">
                  <iframe
                    v-if="
                      (isTextColumn || isImageTextColumn) &&
                        column.categoryCode !== '0' &&
                        detailInfo.uploadNotification
                    "
                    :src="`/lib/pdfjs/web/viewer.html?file=${pdfUrl}`"
                    frameborder="0"
                    class="w-full h-0px"
                    ref="pdfView"
                    @load="pdfViewOnload"
                  ></iframe>
                  <div
                    class="flex mt-15px"
                    v-if="
                      (isTextColumn || isImageTextColumn) &&
                        column.categoryCode !== '0' &&
                        detailInfo.attachFile
                    "
                  >
                    <div>
                      附件：
                    </div>
                    <div class="flex-1">
                      <div v-for="item in attachFileList" :key="item.attachFileName">
                        <a
                          class="underline hyperlink-color mr-50px"
                          :href="item.attachFileDownloadUrl"
                          target="_blank"
                          >{{ item.attachFileName }}</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="ql-editor" v-html="detailInfo.content" ref="richText"></div>
                </div>
                <div v-else>
                  <div class="ql-editor" v-html="detailInfo.content" ref="richText"></div>
                  <iframe
                    v-if="
                      (isTextColumn || isImageTextColumn) &&
                        column.categoryCode !== '0' &&
                        detailInfo.uploadNotification
                    "
                    :src="`/lib/pdfjs/web/viewer.html?file=${pdfUrl}`"
                    frameborder="0"
                    class="w-full h-0px"
                    ref="pdfView"
                    @load="pdfViewOnload"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-30px flex px-50px"
            v-if="
              (isTextColumn || isImageTextColumn) &&
                column.categoryCode !== '0' &&
                detailInfo.attachFile &&
                detailInfo.content &&
                detailInfo.content !== '<p><br></p>'
            "
          >
            <div>
              附件：
            </div>
            <div class="flex-1">
              <div v-for="item in attachFileList" :key="item.attachFileName">
                <a
                  class="underline hyperlink-color mr-50px"
                  :href="item.attachFileDownloadUrl"
                  target="_blank"
                  >{{ item.attachFileName }}</a
                >
              </div>
            </div>
          </div>
          <!-- <div class="border-top-1px border-color-ccc mt-25px mb-10px"></div> -->
          <div class="px-50px mt-35px">
            <div class="flex items-center justify-between text-14px">
              <div class="text-hex-333 flex-1 truncate">
                上一篇：<span
                  v-if="detailInfo.preTable"
                  class="cursor-pointer hover:text-hex-$portalPrimaryColor"
                  @click="toDetail(detailInfo.preTable)"
                  >{{ detailInfo.preTable.title }}</span
                >
                <span v-else>无</span>
              </div>
              <div class="text-hex-999 ml-10px flex items-center">
                <span
                  class="el-icon-printer text-16px cursor-pointer mr-10px"
                  @click="print"
                  v-if="detailInfo.content"
                ></span>
                <span>浏览量：{{ detailInfo.numberViews }}</span>
              </div>
            </div>
            <div class="text-hex-333 text-14px mt-10px">
              下一篇：<span
                v-if="detailInfo.nextTable"
                class="cursor-pointer hover:text-hex-$portalPrimaryColor"
                @click="toDetail(detailInfo.nextTable)"
                >{{ detailInfo.nextTable.title }}</span
              >
              <span v-else>无</span>
            </div>
          </div>
        </div>
        <div
          class="mt-22px border-1px border-[#ccc] py-20px px-50px"
          ref="footer"
          v-if="isShowBottomSidebar"
        >
          <component
            :is="footer.component"
            :data="footer.data"
            mode="view"
            height="auto"
            @nextTick="footerNextTick"
          ></component>
        </div>
      </div>
      <div class="w-280px float-left" v-if="isShowSidebar">
        <div class="border-1px border-[#ccc] px-20px py-15px">
          <component
            :is="upperSideBar.component"
            :data="upperSideBar.data"
            mode="view"
            height="auto"
          ></component>
        </div>
        <div class="border-1px border-[#ccc] px-20px py-15px mt-30px">
          <component
            :is="lowerSideBar.component"
            :data="lowerSideBar.data"
            mode="view"
            height="auto"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  ColumApi,
  ColumnTableApi,
  ColumnPageApi,
  ColumnVisitApi,
  WorkbenchSettingApi,
  ColumnFlowApi,
} from '@wiz-api/workbench'
import Breadcrumb from '@/components/portal/Breadcrumb'
import exportPDF from '@/assets/js/html2pdf'
import { informationPublishMap } from '../../portal-management/js/config'
import NavigationBar from '../../../components/portal/NavigationBar'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const NewsTwo = () => {
  return import('../../../components/portal/NewsTwo')
}
const NewsOne = () => {
  return import('../../../components/portal/NewsOne')
}
const NewsThree = () => {
  return import('../../../components/portal/NewsThree')
}
const NewsFour = () => {
  return import('../../../components/portal/NewsFour')
}
const columnFlowApi = new ColumnFlowApi()
const columApi = new ColumApi()
const columnTypes = informationPublishMap.column
const columnTextType = columnTypes.columnText // 文字栏目
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目
const columnTableApi = new ColumnTableApi()
const columnPageApi = new ColumnPageApi()
const columnVisitApi = new ColumnVisitApi()
const workbenchSettingApi = new WorkbenchSettingApi()

// 栏目详情页
export default {
  name: 'columnDetail',
  components: {
    NavigationBar,
    Breadcrumb,
    NewsOne,
    NewsTwo,
    NewsThree,
    NewsFour,
  },
  data() {
    return {
      detailInfo: {}, // 详情
      type: '',
      attachFileList: [], // 附件信息
      navigationData: null, // 导航信息
      fileLoading: false,
      videoSrc: '',
      breadcrumbData: {},
      columnId: '',
      footer: {},
      upperSideBar: {},
      lowerSideBar: {},
      isShowSidebar: false,
      isShowBottomSidebar: false,
      column: {
        categoryCode: '0',
      },
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
    isVideoColumn() {
      return this.type === columnVideoType
    },
    isTextColumn() {
      return this.type === columnTextType
    },
    isImageTextColumn() {
      return this.type === columnImgTextType
    },
    pdfUrl() {
      return encodeURIComponent(
        `${this.fileUrl}public/preview/${this.detailInfo.uploadNotification}?contentType=application/pdf`
      )
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/`
    },
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()
    },
    dataId() {
      return this.$route.query.id
    },
  },
  watch: {
    dataId: {
      immediate: true,
      handler(val) {
        if (val) {
          const scrollDom = document.getElementsByClassName('homepage-index')[0]
          if (scrollDom) {
            scrollDom.scrollTop = 0
          }
          const richText = document.getElementsByClassName('ql-editor')[0]
          if (richText) {
            richText.style.minHeight = null
          }
          // 跳转到详情页，需要在url地址上携带栏目id和栏目类型(文字、图文、视频)
          const type = this.$route.query.type || ''
          this.type = type * 1
          this.getColumnDetail(val, type * 1)
        }
      },
    },
  },
  mounted() {},
  methods: {
    pdfViewOnload() {
      const contentWindow = this.$refs.pdfView.contentWindow
      const contentDocument = contentWindow.document
      setTimeout(() => {
        const resetFunction = (e) => {
          if (e.pageNumber === contentWindow.PDFViewerApplication.pagesCount) {
            let maxWidth = contentDocument.body.offsetWidth
            _.forEach(contentDocument.getElementsByClassName('page'), (item) => {
              const actualWidth =
                item.offsetWidth / contentWindow.PDFViewerApplication.toolbar.pageScale
              if (actualWidth > maxWidth) {
                maxWidth = actualWidth
              }
            })
            contentWindow.PDFViewerApplication.eventBus.dispatch('scalechanged', {
              source: contentWindow.PDFViewerApplication.toolbar,
              value: _.round(contentDocument.body.offsetWidth / maxWidth, 2),
            })
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
            contentWindow.PDFViewerApplication.eventBus.off('textlayerrendered', resetFunction)
          }
        }
        contentWindow.PDFViewerApplication.eventBus.on('textlayerrendered', resetFunction)
      }, 100)
      // 调整pdf预览样式颜色与主题色一致
      contentDocument.body.style.backgroundColor = 'unset'
      contentDocument.getElementById('toolbarContainer').style.backgroundImage = 'unset'
      contentDocument.getElementById('toolbarContainer').style.backgroundColor = '#c11920'
      contentDocument.getElementById('toolbarSidebar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('toolbarSidebar').style.backgroundImage = 'unset'
      contentDocument.getElementById('findbar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('findbar').style.backgroundImage = 'unset'
      contentDocument.getElementById('secondaryToolbar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('secondaryToolbar').style.backgroundImage = 'unset'
      const selectOptions = contentDocument.querySelectorAll(
        '.dropdownToolbarButton > select > option'
      )
      if (selectOptions) {
        selectOptions.forEach((item) => {
          item.style.backgroundColor = '#c11920'
        })
      }
      const timer = setInterval(() => {
        if (contentWindow.PDFViewerApplication.pdfDocument) {
          clearInterval(timer)
          this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
            .offsetHeight + 100}px`
          setTimeout(() => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }, 500)
          // 缩小
          contentDocument.getElementById('zoomIn').onclick = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
          // 放大
          contentDocument.getElementById('zoomOut').onclick = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
          // 缩放下拉切换
          contentDocument.getElementById('scaleSelect').onchange = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
        }
      }, 500)
      if (!this.detailInfo.isAllowDownload) {
        contentDocument.querySelector('.toolbarButton.download').style.display = 'none'
        contentDocument.querySelector('.toolbarButton.print').style.display = 'none'
      }
    },
    footerNextTick() {
      if (this.detailInfo.uploadNotification) return
      const richText = document.getElementsByClassName('ql-editor')[0]
      if (richText) {
        this.$nextTick(() => {
          richText.style.minHeight = `calc(${this.$refs.detailContainer.parentNode.offsetHeight -
            this.$refs.detailContainer.offsetHeight +
            richText.offsetHeight -
            30}px)`
        })
      }
    },
    print() {
      // const detailInfo = this.$refs.columnDetail.getElementsByClassName('column-author')[0]
      // _.forEach(detailInfo?.children, (item) => {
      //   item.classList.remove('truncate')
      // })
      exportPDF('print', this.$refs.columnDetail, this.detailInfo.title, () => {
        // const detailInfoReset = this.$refs.columnDetail.getElementsByClassName('column-author')[0]
        // _.forEach(detailInfoReset?.children, (item) => {
        //   item.classList.add('truncate')
        // })
      })
    },
    toDetail(data) {
      this.$router.push({
        path: `${this.routerBase}/portal/ColumnDetail`,
        query: {
          id: data.id,
          type: this.type,
        },
      })
    },
    async getSettings() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'columnDetail' })
      if (!err && res.config) {
        const settings = JSON.parse(res.config)
        this.upperSideBar = this.getBarSetting(settings[0])
        this.lowerSideBar = this.getBarSetting(settings[1])
        this.footer = this.getBarSetting(settings[2])
      }
    },
    getBarSetting(data) {
      return {
        component: data.listType,
        data: {
          dataSource: data.dataSource,
          row: data.row,
          col: data.col,
          showDate: data.displayContent.includes('显示时间'),
          showPagination: data.displayContent.includes('显示分页'),
          showTitle: data.displayContent.includes('显示栏目名称'),
          showContent: data.displayContent.includes('显示摘要'),
          showMore: data.displayContent.includes('显示更多'),
          columnTableId: this.dataId,
          columnId: this.columnId,
        },
      }
    },
    handleVideo(videoFileId) {
      this.fileLoading = true
      this.videoSrc = `${this.fileUrl}${videoFileId}/play-video`
      this.fileLoading = false
      // fetch(fetchUrl)
      //   .then((res) => {
      //     return res.blob()
      //   })
      //   .then((blob) => {
      //     const videoUrl = URL.createObjectURL(blob)
      //     this.fileLoading = false
      //     this.videoSrc = videoUrl
      //   })
    },
    async getColumn() {
      const [err, res] = await columApi.getColumnDetail(this.columnId)
      if (!err) {
        this.column = res
      }
    },
    async getColumnDetail(id, type) {
      this.attachFileList = []
      this.detailInfo = {}
      let err
      let res
      // 文字栏目详情
      if (type === columnTextType) {
        ;[err, res] = await columnTableApi.getTextColumnTableDetail(id)
        if (!err) {
          this.handleAttachFile(res)
        }
      }
      // 图文栏目详情
      if (type === columnImgTextType) {
        ;[err, res] = await columnTableApi.getImageColumnTableDetail(id)
        if (!err) {
          this.handleAttachFile(res)
        }
      }
      // 视频栏目详情
      if (type === columnVideoType) {
        ;[err, res] = await columnTableApi.getVideoColumnTableDetail({ id })
        if (!err) {
          res.videoSrc = `${this.fileUrl}${res.videoFile}/play-video`
          this.handleVideo(res.videoFile)
          this.handleAttachFile(res)
        }
      }
      if (res) {
        this.columnId = res.columnId
        await this.getColumn()
        await columnVisitApi.addColumnVisit({
          body: {
            columnId: res.columnId,
            columnTableId: res.id,
            visitor: this.userInfo?.profile?.sub,
          },
        })
        // 获取导航栏信息
        this.getColumnLayout(res.columnId)
        this.getIsShowSidebar(res.columnId)
        this.breadcrumbData = {
          dataSource: res.columnId,
        }
      }
      await this.getSettings()
    },
    async getIsShowSidebar(columnId) {
      const [err, res] = await columApi.getColumnDetail(columnId)
      if (!err && res) {
        this.isShowSidebar = res.isShowSidebar
        this.isShowBottomSidebar = res.isShowBottomSidebar
      }
    },
    async getColumnLayout(id) {
      const [err, res] = await columnPageApi.getColumnPage(1, 1, {
        columnId: id,
        isActive: true,
        type: 0,
      })
      if (!err) {
        const dataItems = res.items || []
        const item = dataItems[0] || {}
        const pageDesign = item.pageDesign ? JSON.parse(item.pageDesign) : []
        const navData = pageDesign[0] && pageDesign[0].data
        this.navigationData = navData || {}
      }
    },
    async handleAttachFile(res) {
      res.creationTime = dayjs(res.creationTime).format('YYYY-MM-DD HH:mm:ss')
      if (res.attachFile) {
        const fileIdList = res.attachFile.split(',')
        this.getAttachFileDownloadInfo(fileIdList, 0)
      }
      this.detailInfo = {
        ...res,
        editPublishTime: res.editPublishTime
          ? dayjs(res.editPublishTime).format('YYYY-MM-DD HH:mm:ss')
          : '',
        content: this.replaceTableWidth(res.content),
      }
      const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
      document.title = `${res.title} - ${config.title}`
    },
    async getAttachFileDownloadInfo(fileIdList, index) {
      if (index >= fileIdList.length) {
        this.fileLoading = false
        return
      }
      const fileId = fileIdList[index]
      if (!fileId) {
        this.getAttachFileDownloadInfo(fileIdList, index + 1)
        return
      }
      this.fileLoading = true
      const [error, result] = await columnFlowApi.getFileInfo(fileId)
      this.fileLoading = false
      if (!error) {
        const fileType = result.name
          .split('.')
          .at(-1)
          .toLowerCase()
        if (['pdf', 'jpg', 'jpeg', 'png', 'mp4'].includes(fileType)) {
          const contentType = {
            png: 'image/png',
            jpeg: 'image/jpeg',
            jpg: 'image/jpeg',
            mp4: 'video/mp4',
            pdf: 'application/pdf',
          }
          this.attachFileList.push({
            id: fileId,
            attachFileName: result.name,
            attachFileDownloadUrl: `/attachments-view?fileId=${fileId}&fileName=${result.name}&contentType=${contentType[fileType]}`,
          })
        } else {
          this.attachFileList.push({
            id: fileId,
            attachFileName: result.name,
            attachFileDownloadUrl: `${this.fileUrl}public/${fileId}/download`,
          })
        }
      }
      this.getAttachFileDownloadInfo(fileIdList, index + 1)
    },
    replaceTableWidth(htmlText) {
      if (!htmlText) {
        return ''
      }
      // 处理历史数据中段落起始为三个空格为两个空格
      if (htmlText.includes('<p>&nbsp; &nbsp; &nbsp;')) {
        htmlText = htmlText.replace('<p>&nbsp; &nbsp; &nbsp;', '<p>&nbsp; &nbsp;')
      }
      // 处理quill-better-table表格超出宽度问题
      if (htmlText.includes('quill-better-table')) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlText
        const colgroupList = tempDiv.querySelectorAll('.quill-better-table colgroup')
        colgroupList.forEach((item) => {
          item.remove()
        })
        htmlText = tempDiv.innerHTML
      }
      // 使用正则表达式匹配<table>标签
      const tableRegex = /<table\b[^>]*>/i
      const tableMatches = htmlText.match(tableRegex)
      if (tableMatches) {
        // 遍历匹配到的<table>标签
        _.forEach(tableMatches, (item) => {
          // 判断是否设置了width属性
          const widthRegex = /width=['"]([^'"]+)['"]/i
          const widthMatch = item.match(widthRegex)
          if (widthMatch) {
            const width = parseInt(widthMatch[[1]], 10)
            // 如果宽度超过780，则替换为780
            if (width > 780) {
              const newTableMatch = item.replace(widthMatch[0], 'width="780"')
              htmlText = htmlText.replace(item, newTableMatch)
              item = newTableMatch
            }
          }
          // 判断是否存在style属性，并且style中是否设置了width
          const styleRegex = /style=['"]([^'"]+)['"]/i
          const styleMatch = item.match(styleRegex)
          if (styleMatch) {
            const style = styleMatch[[1]]
            const newStyle = style.replace(
              /width:\s?[^;]+;/i,
              item.includes('quill-better-table') ? '' : 'table-layout: unset;'
            )
            const newTableMatch = item.replace(styleMatch[0], `style="${newStyle}"`)
            htmlText = htmlText.replace(item, newTableMatch)
          }
        })
      }
      return htmlText
    },
  },
}
</script>
<style scoped lang="scss">
.column-detail {
  &::after {
    content: '';
    display: block;
    clear: both;
  }
}
.detail-w {
  width: var(--portalContainerWidth);
  .ql-editor {
    padding: 12px 0;
  }
}
.hyperlink-color {
  color: #3b9bf0;
}
::v-deep .ql-container.ql-snow {
  border: none;
}
::v-deep .ql-align-center img {
  display: inline-block;
}
.detail-info {
  font-family: Microsoft YaHei;
}
</style>
